import { CompanyTypes, DevicePlatformTypes, LookupTypeDTO } from 'src/services/generated/api.generated.v1';
import { CheckBoxListItem } from 'src/types/custom';

export default class Mapper {
    static MapCheckBoxList(lookup: LookupTypeDTO): CheckBoxListItem {
        return {
            selected: false,
            text: <string>lookup.name,
            description: <string>lookup.description,
            value: lookup.id && lookup.id > 0
                ? lookup.id : <string>lookup.uid
        };
    }

    static MapDevicePlatformType(platform: string): DevicePlatformTypes {
        switch (platform) {
            case 'android':
                return DevicePlatformTypes.Android;
            case 'ios':
                return DevicePlatformTypes.Ios;
            case 'web':
                return DevicePlatformTypes.Web;
            default:
                return DevicePlatformTypes.Unknown;
        }
    }

    static MapCompanyType(companyType: string): CompanyTypes {
        switch (companyType) {
            case 'HRV':
                return CompanyTypes.HRV;
            case 'CRV':
                return CompanyTypes.CRV;
            case 'DRV':
                return CompanyTypes.DRV;
            default:
                return CompanyTypes.Unknown;
        }
    }

    static MapCompanyDisplayName(company: string): string {
        switch (company) {
            case 'CRV':
                return 'Cruiser RVs'
            case 'DRV':
                return 'DRV Suites'
            default:
                return 'Heartland RVs'
        }
    }

    static MapPortalName(company: string): string {
        switch (company) {
            case 'CRV':
                return 'MyCruiserRV'
            case 'DRV':
                return 'MyDRV'
            default:
                return 'MyHeartlandRV'
        }
    }
}